export const STRIPE = "STRIPE";
export const MANUAL = "MANUAL";
export const REST = "REST";
export const CREDIT_PURCHASE = "CREDIT_PURCHASE";

export const PAYMENT_METHODS = {
  STRIPE,
  MANUAL,
};

export const TRANSACTION_TYPES = {
  STRIPE,
  MANUAL,
  REST,
  CREDIT_PURCHASE,
};

export const ABSTRACTION_INITIATED_BY = {
  WEBAPP_API: "WEBAPP_API",
  EMAIL: "EMAIL",
  REST_API: "REST_API",
};

export const CREDIT_ADJUSTMENT_TYPE = {
  PURCHASE: "PURCHASE",
  PROMO_CODE: "PROMO_CODE",
  INITIAL_FREE: "INITIAL_FREE",
  REFERRAL_BONUS: "REFERRAL_BONUS",
  SURVEY_BONUS: "SURVEY_BONUS",
  MANUAL_ADJUSTMENT: "MANUAL_ADJUSTMENT",
  FAILED_ABSTRACTION_REFUND: "FAILED_ABSTRACTION_REFUND",
};
